import axios from 'axios'
export interface EmailValidationResponse {
  isValid: boolean
  didYouMean?: string
  message?: string
}
interface LookupRepositoryResult {
  validateEmail: (email: string, source?: string) => Promise<EmailValidationResponse>
}

const LookupRepository = ({
  lookupServiceURL
}: Record<string, string>): LookupRepositoryResult => {

  const validateEmail = async (email: string, source?: string) => {
    const { data } = await axios.post(`${lookupServiceURL}/EmailValidation/emails/${email}/sources/${source}`)
    return data
  }

  return {
    validateEmail
  }
}


export default LookupRepository
